var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolder = function SvgFolder(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-14": 11,
    "data-width-16": 13,
    "data-width-20": 16.5,
    "data-width-24": 19,
    "data-width-28": 22,
    "data-width-32": 25,
    "data-width-36": 28,
    "data-width-40": 31,
    viewBox: "0 0 10.85 10.2",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.054 0a1.69 1.69 0 0 1 1.459.846L6.27 2.17h3.156a1.365 1.365 0 0 1 1.365 1.365v5.25a1.364 1.364 0 0 1-1.365 1.388H1.365A1.366 1.366 0 0 1 0 8.809V1.37A1.37 1.37 0 0 1 1.365 0zM1.365.875a.496.496 0 0 0-.49.496V8.81a.497.497 0 0 0 .49.489h8.062a.495.495 0 0 0 .49-.49v-5.25a.5.5 0 0 0-.49-.513H6.015a.43.43 0 0 1-.38-.222l-.881-1.528a.82.82 0 0 0-.7-.402zm6.51 5.635a.438.438 0 1 1 0 .875H2.917a.438.438 0 1 1 0-.875z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export default ForwardRef;